/**
 * List of fields to remove when cleaning paths for API requests
 */
const REMOVE_FIELDS = [
  'status',
  'cash_payment',
  'cash_collection',
  'pop_info',
  'proof_of_ *',
  'arrival_lat',
  'arrival_lng',
  'location_sharing',
];

/**
 * Clean paths by removing unwanted fields before sending to API
 * Used in both estimate and create order requests
 */
export function cleanPaths(paths: any[]): any[] {
  return paths.map((p) =>
    Object.fromEntries(
      Object.entries(p).filter(
        ([key]) => !REMOVE_FIELDS.includes(key) && !key.startsWith('proof_of_')
      )
    )
  );
}

/**
 * Clean a single path
 */
export function cleanPath(path: any): any {
  return Object.fromEntries(
    Object.entries(path).filter(
      ([key]) => !REMOVE_FIELDS.includes(key) && !key.startsWith('proof_of_')
    )
  );
}
